import {
	agreementsRightDrawerState,
	formsRightDrawerState,
	recordsRightDrawerState,
	casesRightDrawerState,
} from "../../../store/lyfe-data-table";
import { TableTypes } from "../LyfeDataTable";

export default function getActiveDrawerState(type: TableTypes) {
	switch (type) {
		case "records":
			return recordsRightDrawerState;
		case "agreements":
			return agreementsRightDrawerState;
		case "cases":
			return casesRightDrawerState;
		default:
			return formsRightDrawerState;
	}
}
